// extracted by mini-css-extract-plugin
export default {"divider":"mobile_summary_divider__JCs9t","providerLogo":"mobile_summary_providerLogo__rb73z"};